import { render, staticRenderFns } from "./BBSwitch.vue?vue&type=template&id=e937acb6"
import script from "./BBSwitch.vue?vue&type=script&lang=js"
export * from "./BBSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports